<template></template>
<script>
import axios from "axios";
import constants from "../constants";
export default {
  name: "SessionLogout",
  mounted() {
    axios
      .get(constants.BASE_URL + "/actuator/info", { withCredentials: true })
      .then((response) => window.location = process.env.VUE_APP_CONTEXT_PATH + "/logout")
      .catch((error) => {
        console.error(" Error occured is " + error.message);
        const rootUrl = location.protocol + "//" + location.hostname;
        window.location =
          process.env.VUE_APP_LOGIN_URL + "?redirectUri=" + rootUrl;
      });
  },
};
</script>
